import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './index.scss'

class ToggleX extends Component {
  // constructor (props) {
  //   super(props)
  // }

  render () {
    return (
      <div className={`${this.props.classes} toggle-x`} onClick={this.props.onInputDown}>
        <div><span /></div>
      </div>
    )
  }
}

ToggleX.propTypes = {
  classes: PropTypes.string,
  onInputDown: PropTypes.func
}

export default ToggleX



// WEBPACK FOOTER //
// ./src/components/ToggleX/index.js